// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Select_Wrapper__2Ml75"};